<template>
  <div>
    <el-row>
      <zee-supplier-searchbar></zee-supplier-searchbar>
      <zee-create-supplier></zee-create-supplier>
    </el-row>
    <br>
    <el-row>
      <zee-supplier-list></zee-supplier-list>
    </el-row>
  </div>
</template>


<script>
import zeeCreateSupplier from './partials/CreateSupplier.vue';
import zeeSupplierList from './partials/SupplierList.vue';
import zeeSupplierSearchbar from './partials/Searchbar.vue';

export default {
  components: {
    zeeCreateSupplier,
    zeeSupplierList,
    zeeSupplierSearchbar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/suppliers/Suppliers.vue